import type { ReactNode } from "react";

/**
 * The designer's `.card.empty`: a white card with a 32px grey icon, a short
 * 15px title and one plain line of why and what next, centred. Used for a
 * page that could not load and for "nothing here" states outside a table
 * (a table draws its own, the same way).
 */
export function EmptyCard({
	icon,
	title,
	children,
	actions,
	tone = "muted",
}: {
	icon?: ReactNode;
	title: ReactNode;
	/** The one line under the title. */
	children?: ReactNode;
	/** Buttons under the text — `btn btn-line btn-sm`. */
	actions?: ReactNode;
	/** `bad` tints the icon for a failure. */
	tone?: "muted" | "bad";
}) {
	return (
		<section className="grid justify-items-center gap-[0.5rem] rounded-box border border-gms-line bg-base-100 px-[1rem] py-[2.25rem] text-center text-[0.84375rem] text-gms-ink-2">
			{icon && (
				<span aria-hidden className={`[&>svg]:size-[2rem] ${tone === "bad" ? "text-gms-bad" : "text-gms-ink-3"}`}>
					{icon}
				</span>
			)}
			<b className="text-[0.9375rem] font-semibold text-gms-navy-ink">{title}</b>
			{children && <span className="max-w-[32rem]">{children}</span>}
			{actions && <div className="mt-[0.25rem] flex flex-wrap justify-center gap-[0.5rem]">{actions}</div>}
		</section>
	);
}
